export default __webpack_public_path__ + "static/media/typePickup.cddd7067.cddd7067.svg";